import React, {ReactElement} from 'react';
import {Logo} from '@customink/pigment-react';
import Tooltip from '@mui/material/Tooltip';
import services from '../../api/remoteServices';
import betaBadge from '../../assets/badge.svg';
import './index.scss';

interface BetaBadgeProps {
  hideTooltip: boolean;
}

const BetaBadge: React.FC<BetaBadgeProps> = ({
  hideTooltip
}: BetaBadgeProps): ReactElement => {
  const badgeImage = (
    <img className="betaBadge" src={betaBadge} alt="Beta Badge" />
  );
  return hideTooltip ? (
    badgeImage
  ) : (
    <Tooltip
      className="badgeTooltip"
      title="We're testing out the new Online Stores platform. Use the blue tab on the right to give us feedback."
      arrow
      placement="right-end"
      componentsProps={{
        tooltip: {className: 'tooltip'},
        arrow: {className: 'tooltipArrow'}
      }}>
      {badgeImage}
    </Tooltip>
  );
};

interface Props {
  hideTooltip?: boolean;
}

const HomepageLogo: React.FC<Props> = ({hideTooltip}: Props): ReactElement => {
  return (
    <div className="homepageLogo">
      <a href={services.homePage} rel="noopener noreferrer" target="_blank">
        <Logo
          variant="horizontal"
          height="40px"
          onClick={(): null => null}
          className="inkyLogo"
          placeholder="Custom Ink Logo"
        />
      </a>
      <BetaBadge hideTooltip={hideTooltip} />
    </div>
  );
};

HomepageLogo.defaultProps = {
  hideTooltip: true
};

export default HomepageLogo;
